var _rect, _polygon, _rect2, _path, _polygon2, _circle, _path2, _path3, _path4, _path5, _polygon3, _circle2, _path6, _path7, _rect3, _rect4, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCream(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cream1",
    x: 74,
    y: 32,
    width: 24,
    height: 84
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cream2",
    points: "74 32 98 32 86 14 74 32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cream1",
    x: 30,
    y: 32,
    width: 44,
    height: 84
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cream3",
    d: "M44,0H84a2,2,0,0,1,2,2V14a0,0,0,0,1,0,0H42a0,0,0,0,1,0,0V2A2,2,0,0,1,44,0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cream2",
    points: "74 32 30 32 42 14 86 14 74 32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cream4",
    cx: 52,
    cy: 74,
    r: 11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cream2",
    d: "M74,116v10H96a2,2,0,0,0,2-2v-8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cream2",
    d: "M30,116v8a2,2,0,0,0,2,2H74V116Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cream5",
    d: "M39,124V32L51,14V2a2,2,0,0,1,2-2H44a2,2,0,0,0-2,2V14L30,32v92a2,2,0,0,0,2,2h9A2,2,0,0,1,39,124Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cream6",
    d: "M44,0H84a2,2,0,0,1,2,2V14a0,0,0,0,1,0,0H42a0,0,0,0,1,0,0V2A2,2,0,0,1,44,0Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cream6",
    points: "74 32 30 32 42 14 86 14 74 32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cream6",
    cx: 52,
    cy: 74,
    r: 11
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cream6",
    d: "M74,116v10H96a2,2,0,0,0,2-2v-8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cream6",
    d: "M30,116v8a2,2,0,0,0,2,2H74V116Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cream6",
    x: 30,
    y: 32,
    width: 44,
    height: 84
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cream6",
    x: 74,
    y: 32,
    width: 24,
    height: 84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cream6",
    x1: 98,
    y1: 32,
    x2: 86,
    y2: 14
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCream);
export default __webpack_public_path__ + "static/media/Cream.43e30128d8afd2ece82018099e371928.svg";
export { ForwardRef as ReactComponent };